function f1603(p12838) {
  if (typeof p12838 == "number") {
    p12838 = p12838.toString();
  }
  if (typeof p12838 != "string") {
    throw new Error("Color should be defined as hex string");
  }
  let v10223 = p12838.slice().replace("#", "").split("");
  if (v10223.length < 3 || v10223.length === 5 || v10223.length > 8) {
    throw new Error("Invalid hex color: " + p12838);
  }
  if (v10223.length === 3 || v10223.length === 4) {
    v10223 = Array.prototype.concat.apply([], v10223.map(function (p12839) {
      return [p12839, p12839];
    }));
  }
  if (v10223.length === 6) {
    v10223.push("F", "F");
  }
  const vParseInt29 = parseInt(v10223.join(""), 16);
  return {
    r: vParseInt29 >> 24 & 255,
    g: vParseInt29 >> 16 & 255,
    b: vParseInt29 >> 8 & 255,
    a: vParseInt29 & 255,
    hex: "#" + v10223.slice(0, 6).join("")
  };
}
exports.getOptions = function (p12840) {
  if (!p12840) {
    p12840 = {};
  }
  if (!p12840.color) {
    p12840.color = {};
  }
  const v10224 = typeof p12840.margin == "undefined" || p12840.margin === null || p12840.margin < 0 ? 4 : p12840.margin;
  const v10225 = p12840.width && p12840.width >= 21 ? p12840.width : undefined;
  const v10226 = p12840.scale || 4;
  return {
    width: v10225,
    scale: v10225 ? 4 : v10226,
    margin: v10224,
    color: {
      dark: f1603(p12840.color.dark || "#000000ff"),
      light: f1603(p12840.color.light || "#ffffffff")
    },
    type: p12840.type,
    rendererOpts: p12840.rendererOpts || {}
  };
};
exports.getScale = function (p12841, p12842) {
  if (p12842.width && p12842.width >= p12841 + p12842.margin * 2) {
    return p12842.width / (p12841 + p12842.margin * 2);
  } else {
    return p12842.scale;
  }
};
exports.getImageWidth = function (p12843, p12844) {
  const v10227 = exports.getScale(p12843, p12844);
  return Math.floor((p12843 + p12844.margin * 2) * v10227);
};
exports.qrToImageData = function (p12845, p12846, p12847) {
  const v10228 = p12846.modules.size;
  const v10229 = p12846.modules.data;
  const v10230 = exports.getScale(v10228, p12847);
  const v10231 = Math.floor((v10228 + p12847.margin * 2) * v10230);
  const v10232 = p12847.margin * v10230;
  const vA561 = [p12847.color.light, p12847.color.dark];
  for (let vLN01637 = 0; vLN01637 < v10231; vLN01637++) {
    for (let vLN01638 = 0; vLN01638 < v10231; vLN01638++) {
      let v10233 = (vLN01637 * v10231 + vLN01638) * 4;
      let v10234 = p12847.color.light;
      if (vLN01637 >= v10232 && vLN01638 >= v10232 && vLN01637 < v10231 - v10232 && vLN01638 < v10231 - v10232) {
        const v10235 = Math.floor((vLN01637 - v10232) / v10230);
        const v10236 = Math.floor((vLN01638 - v10232) / v10230);
        v10234 = vA561[v10229[v10235 * v10228 + v10236] ? 1 : 0];
      }
      p12845[v10233++] = v10234.r;
      p12845[v10233++] = v10234.g;
      p12845[v10233++] = v10234.b;
      p12845[v10233] = v10234.a;
    }
  }
};